import React, { useCallback, useEffect, useRef, useState } from 'react';
import c from 'classnames';

import {
  NavigationScroll,
  useTrapFocus,
} from '@uncinc/uncinc-react-kitchen-sink';

import Overlay from './Overlay';
import Header from './Header';

import './style.scss';

const MainMenu = () => {
  const menu = useRef(null);

  const isOverlayOpen = useRef(false);
  const [isOpen, setIsOpen] = useState(false);
  const menuButton = useRef(null);
  const lottie = useRef(null);

  useTrapFocus({ ref: menu, isActive: isOpen });

  const toggleOverlayOpen = useCallback((onlyClose = false) => {
    if (!onlyClose || isOverlayOpen.current) lottie.current.play();
    isOverlayOpen.current = (onlyClose) ? false : !isOverlayOpen.current;
    setIsOpen(isOverlayOpen.current);

    menuButton.current.className = isOverlayOpen.current
      ? 'Header__menu hide'
      : 'Header__menu show';

    if (menu.current) {
      menu.current.className = `MainMenu ${isOverlayOpen.current && 'overlay-menu-open'}`;
    }
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && isOverlayOpen.current) toggleOverlayOpen(true);
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [toggleOverlayOpen]);

  const MainMenuClassnames = c(
    'MainMenu',
    { 'overlay-menu-open': isOverlayOpen.current },
  );

  return (
    <NavigationScroll>
      <div
        ref={menu}
        className={MainMenuClassnames}
      >

        <Header
          key="header"
          isOpen={isOpen}
          isOverlayOpen={isOverlayOpen}
          toggleOverlayOpen={toggleOverlayOpen}
          menuButtonRef={menuButton}
          lottieRef={lottie}
        />

        <Overlay toggleOverlayOpen={toggleOverlayOpen} />

      </div>
    </NavigationScroll>
  );
};

export default MainMenu;
